module.exports = __webpack_public_path__ + "static/media/desktop_dark.009d8983.svg";